import { createStyles, fade, makeStyles } from '@material-ui/core/styles';

import { colorsPalette } from '../../../../../../theme';

export const useStyles = makeStyles((theme) =>
  createStyles({
    pickerWrapper: {
      '& .DayPicker-Months': {
        flexWrap: 'nowrap',
      },
      '& .DayPicker-Weekdays': {
        display: 'block',
        padding: '0 28px',
        margin: 0,
      },
      '& .DayPicker-WeekdaysRow': {
        display: 'flex',
        justifyContent: 'space-around',
      },
      '& .DayPicker-Weekday': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'calc(100% / 7)',
      },
      '& .DayPicker-Body': {
        display: 'block',
        padding: '0 28px',
      },
      '& .DayPicker-Week': {
        display: 'flex',
        justifyContent: 'space-around',
      },
      '& .DayPicker-Day': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 'calc(100% / 7)',
        margin: '1px 0',
      },
      '& .DayPicker-Day--outside': {
        visibility: 'hidden',
      },
      '& .DayPicker-Day--disabled': {
        color: fade(colorsPalette.white, 0.33),
        pointerEvents: 'none',
      },
      '&.DayPicker': {
        width: '100%',
        fontSize: 14,
        [theme.breakpoints.up('lg')]: {
          width: 'initial',
        },
      },
      '& .DayPicker-Day--today': {
        color: colorsPalette.white,
      },
      '& .DayPicker-Month': {
        display: 'block',
        margin: 0,
        width: '100%',
        [theme.breakpoints.up('lg')]: {
          width: 380,
        },
        '&:even': {
          position: 'relative',
          marginLeft: 24,
          paddingLeft: 24,
          '&:after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: 1,
            height: 'calc(100% - 90px)',
            background: fade(colorsPalette.white, 0.16),
          },
        },
      },
      '& .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover': {
        background: colorsPalette.blue,
      },
      '& .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)': {
        borderRadius: 0,
        margin: '1px 0',
        padding: 7,
        background: fade(colorsPalette.blue, 0.33),
      },
      '& .DayPicker:not(.DayPicker--interactionDisabled),& .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover': {
        position: 'relative',
        zIndex: 1,
        background: 'transparent !important',
        '&:after': {
          content: '""',
          position: 'absolute',
          left: '50%',
          top: '50%',
          zIndex: -1,
          transform: 'translate(-50%, -50%)',
          width: 36,
          height: 36,
          borderRadius: 18,
          background: colorsPalette.blue,
        },
      },
      '& .DayPicker-Day--start, & .DayPicker-Day--end': {
        position: 'relative',
        zIndex: 1,
        background: 'transparent !important',
        '&:after': {
          content: '""',
          position: 'absolute',
          left: '50%',
          top: '50%',
          zIndex: -1,
          transform: 'translate(-50%, -50%)',
          width: 36,
          height: 36,
          borderRadius: 18,
          background: colorsPalette.blue,
        },
      },
      '& .DayPicker-Day--start': {
        '&:before': {
          content: '""',
          position: 'absolute',
          left: '50%',
          top: '50%',
          zIndex: -1,
          transform: 'translateY(-50%)',
          width: '50%',
          height: '100%',
          background: fade(colorsPalette.blue, 0.33),
        },
      },
      '& .DayPicker-Day--end': {
        '&:before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: '50%',
          zIndex: -1,
          transform: 'translateY(-50%)',
          width: '50%',
          height: '100%',
          background: fade(colorsPalette.blue, 0.33),
        },
      },
    },
    navigationButton: {
      minWidth: 54,
      width: 54,
      height: 54,
      borderRadius: '50%',
    },
  }),
);
